import React, { Component } from "react";
import { Bar } from "@ant-design/charts";

const fileTypeOptions = ["svg", "png", "jpg", "gif"];

// const fileTypeDataset = (d) => {
//   var data = [];
//   fileTypeOptions.forEach((fileType) => {
//     const dataFileType = [
//       {
//         type: fileType,
//         images: d.filter(function (image) {
//           return image.file_type == fileType;
//         }).length,
//       },
//     ];
//     data = data.concat(dataFileType);
//   });

//   return data;
// };

const fileTypeDataset = (d) => {
  var data = [];
  fileTypeOptions.forEach((fileType) => {
    const dataFileType = [
      {
        type: fileType,
        resolution: "High-res",
        value: d.filter(function (image) {
          return image.resolution == "High-res" && image.file_type == fileType;
        }).length,
      },
      {
        type: fileType,
        resolution: "Mid-res",
        value: d.filter(function (image) {
          return image.resolution == "Mid-res" && image.file_type == fileType;
        }).length,
      },
      {
        type: fileType,
        resolution: "Low-res",
        value: d.filter(function (image) {
          return image.resolution == "Low-res" && image.file_type == fileType;
        }).length,
      },
    ];
    data = data.concat(dataFileType);
  });

  return data;
};

export default class BarChartFileTypes extends Component {
  render() {
    // const config = {
    //   data: fileTypeDataset(this.props.data),
    //   xField: "images",
    //   yField: "type",
    //   color: "#40A9FF",
    //   legend: false,
    //   label: null,
    // };

    const config = {
      data: fileTypeDataset(this.props.data),
      isStack: true,
      xField: "value",
      yField: "type",
      seriesField: "resolution",
      color: ["#40A9FF", "#91D5FF", "#FF7875"],
      legend: {
        position: "top",
      },
      label: null,
    };

    return <Bar {...config} />;
  }
}
